let html = `<div class="extensions__item extensions__item--recomend selector layer--visible layer--render">
    <div class="extensions__item-imagebox">
        <img class="extensions__item-image" />
    </div>
    <div class="extensions__item-body">
        <div class="extensions__item-author"></div>
        <div class="extensions__item-name"></div>
        <div class="extensions__item-descr"></div>
        <div class="extensions__item-footer">
            <div class="extensions__item-included hide"></div>
            <div class="extensions__item-check hide"></div>
            <div class="extensions__item-code hide success"></div>
            <div class="extensions__item-status hide"></div>
            <div class="extensions__item-disabled hide">#{player_disabled}</div>
        </div>
    </div>
</div>`

export default html